<template>
  <div class="root">
    <v-card outlined class="pa-2 pt-1">
      <div class="d-flex justify-space-between align-top">
        <div class="font-weight-light blue--text">{{ moment(value.created_at).format('DD.MM.YY HH:mm') }}</div>
        <v-btn
          v-if="hasDelete"
          icon
          @click="dialog = true"
          class="button-delete"
          color="gray"
        >
          <v-icon size="20px">mdi-trash-can-outline</v-icon>
        </v-btn>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="3">
            <v-text-field
              ref="discount"
              v-model="discount"
              type="number"
              :label="labelText"
              :error-messages="errorMessages"
              autocomplete="off"
              :rules="rules"
            />
          </v-col>
          <v-col cols="4">
            <v-switch
              v-model="type"
              :label="
                lang($store, 'sap/listings.global.filter.hints.discount_money')
              "
              :disabled="this.discount > 100"
            />
          </v-col>
          <v-col cols="5">
            <v-select
              v-model="reasonType"
              :items="reasonItems"
              single-line
              :hint="
                lang($store, 'sap/listings.global.filter.hints.discount_reason')
              "
              persistent-hint
            ></v-select>
          </v-col>
        </v-row>
        <v-text-field
          ref="comment"
          v-model="comment"
          :label="lang($store, 'sap/listings.global.filter.hints.minicomment')"
        />
      </v-form>
    </v-card>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Удалить дисконт?
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            Отмена
          </v-btn>

          <v-btn color="green darken-1" text @click="onDelete">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { REASONS, OTHER, DISCOUNT_DONE } from '@/constants/discount';

export default {
  name: 'DiscountField',
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [Array, String],
      default: () => []
    },
    hasDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moment,
      valid: true,
      discount: this.value.value || 0,
      OTHER,
      DISCOUNT_DONE,
      rules: [
        v => (!Number.isNaN(v) && v > 0) ||
          'Скидка должна быть положительным числом'
      ],
      /* noteRules: [
        () => this.reasonType === OTHER,
        v => !!v || 'Введите комментарий',
        v => (v && v.length > 2) || 'Введите комментарий'
      ], */
      type: this.value.isMoney,
      reasonType: this.value.reason,
      comment: this.value.note,
      dialog: false
    };
  },
  computed: {
    reasonItems() {
      return REASONS.map(value => ({
        text: this.lang(
          this.$store,
          `sap/listings.global.filter.discount_reasons.${value}`
        ),
        value
      }));
    },
    labelText() {
      if (!this.label) {
        return this.lang(
          this.$store,
          'sap/listings.global.filter.hints.discount'
        );
      }
      return this.label;
    }
    /* discount: {
      get() {
        return this.value.discount;
      },
      set(value) {
        debugger;
        if (Number.isNaN(value) || (!Number.isNaN(value) && value < 0)) {
          this.$emit('input', this.getFullValue()); // fix issue with text field. changed on next refresh
          this.$nextTick(() => {
            this.$emit('input', this.getFullValue());
          });
          return;
        }
        const v = Number.parseInt(value, 10);
        if (!this.isMoney && v > 100) {
          this.type = true;
        }

        this.$emit('input', this.getFullValue());
      }
    }, */
  },
  watch: {
    discount() {
      const value = this.discount;
      /* if (Number.isNaN(value) || (!Number.isNaN(value) && value < 0)) {
        this.$emit('input', this.getFullValue()); // fix issue with text field. changed on next refresh
        this.$nextTick(() => {
          this.$emit('input', this.getFullValue());
        });
        return;
      } */
      const v = Number.parseInt(value, 10);
      if (v < 0) this.discount = 1;
      if (!this.isMoney && v > 100) {
        this.type = true;
      }

      this.$emit('input', this.getFullValue());
    },
    type() {
      this.$emit('input', this.getFullValue());
    },
    comment() {
      this.$emit('input', this.getFullValue());
    },
    reasonType() {
      this.$refs.form.resetValidation();
      if (this.reasonType === OTHER && !this.comment) {
        this.$refs.comment.focus();
        this.$refs.form.validate();
      }
      if (this.valid) {
        this.$emit('input', this.getFullValue());
      }
    }
  },
  methods: {
    getFullValue() {
      return {
        id: this.value.id,
        value: this.discount >= 0 ? this.discount : 0,
        is_money: this.type,
        reason: this.reasonType,
        note: this.comment
      };
    },
    onDelete() {
      this.dialog = false;
      this.$emit('onDelete', this.value.id);
    }
  }
};
</script>
